import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import success from "../assets/json/success.json";
import { useNavigate } from "react-router-dom";

const SuccessMessage = ({ message, total }) => {
    const navigate = useNavigate();
    const currentDateTime = new Date();

    const formattedDate = currentDateTime.toLocaleDateString([], {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
    const formattedTime = currentDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });

    const [timer, setTimer] = useState(15); 

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(countdown);
                    navigate("/cart");
                }
                return prev - 1;
            });
        }, 1500);

        return () => clearInterval(countdown);
    }, [navigate]);

    const cart = () => {
        navigate("/cart");
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-[white/50] backdrop-blur">
            <div
                className="bg-green-100 border border-green-300 rounded-lg p-6 shadow-lg flex flex-col items-center lg:w-[30%] w-[90%] md:w-[40%] sm:w-[60%]"
                style={{ height: "auto", backgroundColor: "white" }}
            >
                <Lottie loop={false} animationData={success} className="h-24 w-24" />
                <span className="text-2xl font-bold text-[green] mt-4 font-display">Hurray!</span>
                <p className="text-lg font-semibold">Order placed successfully 🎉</p>

                <span className="lg:text-2xl text-xl font-bold text-green-700 mt-4 font-display">{message}</span>
                {/* <span className="text-sm  text-green-700 mt-4 font-display">Total: ₹{total}</span> */}

                <span className="text-sm  text-green-700 mt-4 font-display">Date: {formattedDate}</span>
                <span className="text-sm  text-green-700 mt-1 font-display">Time: {formattedTime}</span>

                {/* Countdown timer display */}
                <p className="mt-4 text-sm text-gray-600">Redirecting to cart in <b>{timer}</b> seconds...</p>

                <div
                    className="mt-6 text-[white] bg-[#8B0000] font-bold py-3 px-6 rounded-[5px] font-display cursor-pointer"
                    onClick={cart}
                >
                    Back to Cart
                </div>
            </div>
        </div>
    );
};

export default SuccessMessage;
